module.exports = __webpack_public_path__ + "media/video_03.cd3ae128.mp4";